export enum FelloWebsites {
  PRIVACY_POLICY = "https://hifello.com/privacy-policy",
  TERMS_AND_CONDITIONS = "https://hifello.com/terms-and-conditions",
  ACCEPTABLE_USE_POLICY = "https://hifello.com/acceptable-use-policy",
  CONTACT_US = "https://hifello.com/knowledge/kb-tickets/new",
  SHARED_BILLING_TERMS_AND_CONDITIONS = "https://hifello.com/shared-billing-terms-and-conditions"
}
